import { getRequestData } from '../../Utility/apiHelper';
import { requestHideLoader, requestShowLoader } from '../Global/action';
import * as actionType from './type';


export const requestGetAllPermission = () => async(dispatch) => {
    try {


        dispatch(requestShowLoader());


        const responseData = await getRequestData(`permissions`);
        const {data} = responseData;
        dispatch({
            type: actionType?.RECEIVED_ALL_PERMISSION_TYPE,
            payload: data
        })
        dispatch(requestHideLoader());
    } catch(error) {
        dispatch(requestHideLoader());
    }
}

export const requestGetAllRoles = () => async(dispatch) => {
    try {



        dispatch(requestShowLoader());


        const responseData = await getRequestData(`roles`);
        const {data} = responseData;

        dispatch({
            type: actionType?.RECEIVED_ALL_ROLES,
            payload: data
        })
        
        dispatch(requestHideLoader());
    } catch(error) {
        dispatch(requestHideLoader());
    }
}
